module.exports = __webpack_public_path__ + "static/img/topic.a918a64b.png";